export default {
  FP_ZONE_LIBRE: "FP_Zone_Libre"
}
